module.exports = __webpack_public_path__ + "static/zoya-logo-2e322fe48a5b5afba94e77e343fe55d2.png";